import { combineReducers } from 'redux';

import fetch, * as fromFetch from './fetch';
import update, * as fromUpdate from './update';
import currentDate, * as fromCurrentDate from './currentDate';

export default combineReducers({
  fetch,
  update,
  currentDate,
});

export const areFetching = (state) => fromFetch.areFetching(state.fetch);

export const getLabels = (state) => fromFetch.getLabels(state.fetch);

export const getLabel = (state, id) => fromFetch.getLabel(state.fetch, id);

export const areSaving = (state) => fromFetch.areSaving(state.update);

export const isModalVisible = (state) => fromUpdate.isModalVisible(state.update);

export const getId = (state) => fromUpdate.getId(state.update);

export const getTitle = (state) => fromUpdate.getTitle(state.update);

export const getDescription = (state) => fromUpdate.getDescription(state.update);

export const getDuration = (state) => fromUpdate.getDuration(state.update);

export const getColor = (state) => fromUpdate.getColor(state.update);

export const getCurrentDate = (state) => fromCurrentDate.getCurrentDate(state.currentDate);
